import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img alt=""
                                                                                     src={require('@images/greendot.jpg')}/>FOCUS
                                                FOR SUCCESS
                                            </div>
                                            <p>Here are the key aspects of the V-SPORT model in greater
                                                detail:</p>
                                            <span className="greennumberroundbg_green"
                                                  style={{fontFamily:'Berthold Akzidenz Grotesk Regular'}}>V</span><span
                                            className="greensubtitle3">ision</span>
                                            <p className="pbodyfont_modified" style={{clear: 'both'}}>This is the cornerstone of the
                                                whole strategy and provides direction for the long-term
                                                goals. Putting this in writing to formalise it is
                                                extremely important. Ideally you should try to write this in
                                                a compelling, inspirational way as well as making it clear
                                                and transparent.
                                                People need to clearly understand – and identify with – the
                                                vision and direction.</p>
                                            <p className="pbodyfont_modified">Consider how this aligns with
                                                overall organisational goals and, as important, try to
                                                demonstrate that it contributes
                                                to individuals’ personal and career goals, team goals and
                                                departmental goals. People are motivated by opportunities
                                                for personal development and
                                                if the strategy offers this you will gain commitment which,
                                                in turn, maintains momentum.</p>
                                            <div className="uiheading"><p
                                                className="pbodyfont_modified">Consider the following
                                                questions to fully understand and build your own and others'
                                                commitment to your vision:</p></div>
                                            <div className="indicatorlist_new greenbullet-list">
                                                <ul>
                                                    <li>What is your end goal?</li>
                                                    <li>Why is this important to you?</li>
                                                    <li>What are the implications of not achieving this
                                                        outcome?
                                                    </li>
                                                    <li>What benefits will achieving this outcome bring to
                                                        you/the organisation?
                                                    </li>
                                                </ul>
                                            </div>
                                            <span className="greennumberroundbg_green"
                                                  style={{fontFamily:'Berthold Akzidenz Grotesk Regular'}}>S</span><span
                                            className="greensubtitle3">takeholders</span>
                                            <p className="pbodyfont_modified" style={{clear: 'both'}}>It’s important to consider the
                                                people who have some stake in the success of the strategy.
                                                This includes those who contribute to the initial vision
                                                statement, those who will have to be involved or will be
                                                affected at some stage of the process and those who will be
                                                affected by its outcome.
                                                Think about your audience and how you’re going to explain
                                                the translation of the vision into actions. To do this, look
                                                at it from an outsider’s
                                                perspective – what impact will your goal have on individuals
                                                and other functions within or connected to the
                                                organisation?</p>
                                            <div className="uiheading"><p
                                                className="pbodyfont_modified">Decide how consultative you
                                                need to be in order to gain maximum benefitts.</p></div>
                                            <div className="indicatorlist_new">
                                                <ul>
                                                    <li>Do you need to consult with anyone before rolling
                                                        out the vision to others?
                                                    </li>
                                                    <li>Who would this be with?</li>
                                                    <li>How will it be conducted?</li>
                                                </ul>
                                            </div>
                                            <p className="pbodyfont_modified">This doesn’t mean that every
                                                stage has to be negotiated but it does mean that goals
                                                should be consistent with expectations and address
                                                concerns.</p>
                                            <span className="greennumberroundbg_green"
                                                  style={{fontFamily:'Berthold Akzidenz Grotesk Regular'}}>P</span><span
                                            className="greensubtitle3">riorities</span>
                                            <p className="pbodyfont_modified" style={{clear: 'both'}}>It will be important for you
                                                and others actioning the strategy to be able to easily
                                                identify the priorities in order to succeed. Take into
                                                consideration the complexity of the task and make sure you
                                                prioritise critical ‘milestones’, tasks and actions. You
                                                could use a graph like this:</p>
                                            <div className="chart_image" align="center">
                                                <img
                                                    src={require('@images/Long-term-image_chart.png')}/>
                                            </div>
                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page2')}
                                                     className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}